import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { HttpClientModule } from '@angular/common/http';
import { httpInterceptorProviders } from './interceptors';
import { TokenGuard } from './guards/token.guard';
import { TokenComponent } from './components/token/token.component';
import { DatePipe } from '@angular/common';
import { SlugPageComponent } from './components/slugPage/slug-page.component';
import { LayoutModule } from './layout/layout/layout.module';
import { SettingsModule } from './components/settings/settings.module';
import { AdminSetariModule } from './platform/nomenclatoare/administrativ/admin-setari/admin-setari.module';
import { BorderouModule } from './components/borderou/borderou.module';
import { SabloaneModule } from './components/sabloane/sabloane.module';
import { EntitatiModule } from './components/entitati/entitati.module';
import { VerificareEvidentaModule } from './components/verificare-evidenta/verificare-evidenta.module';
import { DecedatiModule } from './components/decedati/decedati.module';
import { RapoarteModule } from './components/rapoarte/rapoarte.module';
import { RegistruModule } from './components/registru/registru.module';
import { DashboardModule } from './components/dashboard-documente/dashboard.module';
import { InboxModule } from './components/inbox/inbox.module';
import { NotificariModule } from './components/notificari/notificari.module';
import { AwbModule } from './components/awb/awb.module';
import { ToastrModule } from 'ngx-toastr';
import { RapoarteActivitateModule } from './components/rapoarte-activitate/rapoarte-activitate.module';
import { RaportActivitateDetaliatModule } from './components/raport-activitate-detaliat/raport-activitate-detaliat.module';
import { OperatorSigningLogsModule } from './components/operator-signing-logs/operator-signing-logs.module';
import { AuditLogsModule } from './components/audit-logs/audit-logs.module';

@NgModule({
    declarations: [AppComponent, TokenComponent, SlugPageComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MaterialModule,
        HttpClientModule,
        LayoutModule,
        SettingsModule,
        AdminSetariModule,
        BorderouModule,
        SabloaneModule,
        EntitatiModule,
        VerificareEvidentaModule,
        DecedatiModule,
        RapoarteModule,
        RegistruModule,
        DashboardModule,
        InboxModule,
        NotificariModule,
        AwbModule,
        RapoarteActivitateModule,
        RaportActivitateDetaliatModule,
        OperatorSigningLogsModule,
        AuditLogsModule,
        ToastrModule.forRoot(),
    ],
    providers: [httpInterceptorProviders, TokenGuard, DatePipe],
    bootstrap: [AppComponent],
})
export class AppModule { }
